module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/420.45af2386.png";